export default "__VITE_ASSET__Gh_dGYlJ__"